import { render, staticRenderFns } from "./informationPerfect.vue?vue&type=template&id=1a072570&scoped=true&lang=html&"
import script from "./informationPerfect.vue?vue&type=script&lang=js&"
export * from "./informationPerfect.vue?vue&type=script&lang=js&"
import style0 from "./informationPerfect.vue?vue&type=style&index=0&id=1a072570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a072570",
  null
  
)

export default component.exports